import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    flex
    items-center
    justify-center
    overflow-hidden
  `,
  slots: {
    youtubePlayer: `
      [&_iframe]:max-w-full
    `,
    sketchFab: `
      h-full
      w-full
    `,
  },
});
